/* EV V4, 17 sep 2026: het kenmerk _agentClientInfo van de winkelwagen wissen op
   het moment dat de bezoeker naar de kassa gaat.

   Waarom dit bestaat: de Shopify-integratie van Microsoft Clarity schrijft bij
   elke paginaweergave een winkelwagenkenmerk _agentClientInfo met sessie- en
   gebruikersnummers. Dat kenmerk belandt op de bestelling, onder Additional
   details, en Keira meldde dat drie keer. Het blok brandAgents_js staat al uit,
   dus de winkelassistent is niet de bron; het is het opnamescript zelf, en dat
   moet blijven draaien. Gemeten op 17 september: het kenmerk staat er weer
   binnen enkele seconden na elke paginawissel, dus een eenmalige opruiming
   helpt niet.

   Twee regels waar dit script zich aan houdt:
   1. Nooit preventDefault en nooit wachten. Een klik op Afrekenen gaat altijd
      door, ook als dit verzoek faalt. Een verloren bestelling is oneindig veel
      erger dan een regel rommel in de beheeromgeving.
   2. keepalive, zodat het verzoek doorloopt terwijl de pagina al navigeert.

   Na de klik staat de bezoeker op de kassa van Shopify, waar dit script en het
   script van Clarity niet draaien, dus het kenmerk komt daar niet terug. */
(function () {
  var VELD = '_agentClientInfo';

  function wis() {
    try {
      var body = {};
      body[VELD] = '';
      fetch('/cart/update.js', {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: body })
      }).catch(function () {});
    } catch (e) {}
  }

  var SELECTORS = [
    '[name="checkout"]',
    'a[href*="/checkout"]',
    '.shopify-payment-button__button',
    'shopify-accelerated-checkout button'
  ].join(',');

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest(SELECTORS) : null;
    if (el) wis();
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    var actie = f.getAttribute('action') || '';
    if (actie.indexOf('/cart') === 0 || actie.indexOf('/checkout') === 0) wis();
  }, true);
})();
